import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {Assembly, AssemblyInfo, AXIOS_CANCEL_MSG, Page} from '../api/models';
import { ConfiguratorContext } from '../context';
import {AssemblyFilterOptions, FilteredAssembliesRequest} from "../api";
import {SorterResult, SortOrder} from "antd/es/table/interface";

interface QuoteSelectionInfoProps {
  selections?: number[]
  pricingSnapshotId?: number
  quoteRevisionId?: number
  serialNumber?: string
  truckId?: number
}

export const useQuoteSelectionInfoList = (props: QuoteSelectionInfoProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:QuoteSelectionInfoProps  ) : Promise<AssemblyInfo[] | undefined> => {

    if ( !( props.pricingSnapshotId || props.quoteRevisionId || props.selections?.length || props.truckId || props.serialNumber ) ) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchSelectionInfo(props, cancelSource.token )
      cancelTokenSourceRef.current = undefined;

      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  }

  // Use SWR for data fetching
  return useSWR([
    'fetchSelectionInfo',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      //maybe unnecessary
      revalidateOnFocus: false,
      //maybe unnecessary
      dedupingInterval:1 
    }
  );
};


export default useQuoteSelectionInfoList;

